"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var chalk_1 = __importDefault(require("chalk"));

var loglevel_1 = __importDefault(require("loglevel"));

var loglevel_plugin_prefix_1 = __importDefault(require("loglevel-plugin-prefix"));

var colors = {
  TRACE: chalk_1.default.magenta,
  // tslint:disable-next-line: object-literal-sort-keys
  DEBUG: chalk_1.default.cyan,
  INFO: chalk_1.default.blue,
  WARN: chalk_1.default.yellow,
  ERROR: chalk_1.default.red
};

var Logger =
/** @class */
function () {
  function Logger(logLevel) {
    this.log = loglevel_1.default.noConflict();
    this.log.setLevel(logLevel);
    loglevel_plugin_prefix_1.default.reg(this.log);
    loglevel_plugin_prefix_1.default.apply(this.log, {
      format: function format(level, name, timestamp) {
        var niceLevel = level.toUpperCase();
        return timestamp + " :: " + colors[niceLevel](niceLevel.toUpperCase()) + " :: " + chalk_1.default.cyan(name) + " : ";
      }
    });
    this.log.debug("Logger has been created");
  }

  Logger.prototype.getLogger = function (name) {
    return this.log.getLogger(name);
  };

  return Logger;
}();

exports.Logger = Logger;